const initialState = {
    data: [],
};
  
const userPasswordSendReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_USER_PASSWORD_SEND':
      return { ...state, data: action.payload };
    default:
      return state;
  }
};

export default userPasswordSendReducer;